import { Tabs, Drawer, Popover } from "antd";
import React, {
  forwardRef,
  useState,
  useRef,
  useImperativeHandle,
  useEffect,
  useCallback,
} from "react";
import http from "@/utils/http";
import api from "@/utils/api";
import "./InsuranceVPH.scss";
import moment from "moment";
import commonFn from "@/utils/commonFn";
import PropDetailModal from "@/views/AccountPayable/BusinessLicense/components/PropDetailModal";
import PolicyNumber from "@/views/AccountPayable/ApprovalSummary/component/PolicyNumber";
import RemarkPopover from "@/views/AccountPayable/ApprovalSummary/component/RemarkPopover";
const MainTable = forwardRef((props, ref) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [VPHprop, setVPHProp] = useState("");
  const [VPHList, setVPHList] = useState([]);
  const [tabsKey, setTabsKey] = useState("1");
  const [propRecord, setPropRecord] = useState({});
  const [loading, setLoading] = useState(false);
  const [VPHGLAcct, setVPHGLAcct] = useState([]);
  const propDetailModalRef = useRef(null);

  // 提取请求函数，使用 useCallback 避免重复创建
  const viewPaymentHAmountFn = useCallback(async (record) => {
    if (!record?.propId) return;

    setLoading(true);
    try {
      const params = {
        propId: record.propId,
      };

      const response = await http.get(api.getInsuranceByPropAmount, { params });

      if (response?.code === "1") {
        setVPHProp(response.data?.prop || "");
        setVPHList(response.data?.yearGroups || []);
        setVPHGLAcct(response.data?.pendingInsuranceGlAcctGroups || []);
      } else {
        setVPHProp("");
        setVPHList([]);
        setVPHGLAcct([]);
      }
    } catch (error) {
      setVPHProp("");
      setVPHList([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // 打开 Drawer 的方法
  const openDrawer = useCallback(
    async ({ record }) => {
      setVPHProp("");
      setVPHList([]);
      setVPHGLAcct([]);
      setPropRecord(record);
      setTabsKey("1");
      setDrawerOpen(true);

      await viewPaymentHAmountFn(record);
    },
    [viewPaymentHAmountFn],
  );

  useImperativeHandle(ref, () => ({
    setModalOpen: openDrawer,
  }));

  const viewPaymentHUnitFn = useCallback(async (record) => {
    propDetailModalRef.current?.openModal({
      modalName: "View Property Detail",
      propId: record?.propId,
      isModal: false,
    });
  }, []);

  const handleClose = useCallback(() => {
    setVPHProp("");
    setVPHList([]);
    setPropRecord({});
    setDrawerOpen(false);
    setLoading(false);
    setVPHGLAcct([]);
  }, []);

  useEffect(() => {
    if (tabsKey === "2" && propRecord?.propId) {
      viewPaymentHUnitFn(propRecord);
    }
  }, [tabsKey, propRecord, viewPaymentHUnitFn]);

  const renderCards = (list = [], isYear = true) =>
    list.map((item, index) => {
      const showAvg = isYear
        ? item?.showYearAverage
        : item?.showCurrentYearWithPendingAverage;
      const avg = isYear
        ? item.yearAverage
        : item.currentYearWithPendingAverage;

      return (
        <div className="ASIDInsuranceItem" key={index}>
          <div className="ASIDItemTotal ASIDItemTotalAuto">
            <div className="ASIDItemTopYear">
              {commonFn.iconDocFn({
                iconKey: "ASIDYear",
                width: 24,
                height: 24,
                marginRight: 4,
              })}
              {isYear ? (
                item.year
              ) : (
                <div>
                  <div>Pending</div>
                  <div className="ASIDItemTopPendingValue">
                    {commonFn.amountToDollarFn(
                      item.currentYearWithPendingTotal,
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="ASIDItemTopAmount">
              <div className="ASIDItemTopAmountName">
                {isYear ? "Total amount" : "Total"}
              </div>
              <div className="ASIDItemTopAmountValue ASIDFont20">
                {commonFn.amountToDollarFn(item.yearTotal)}
              </div>
              {showAvg && (
                <>
                  <div className="ASIDItemTopAmountName">Per Unit</div>
                  <div className="ASIDItemTopAmountValue">
                    {commonFn.amountToDollarFn(avg)}
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="ASIDItemGlAcctList">
            {item?.glAcctGroups?.length ? (
              item.glAcctGroups.map((value, idx) => (
                <div className="ASIDItemGlAcctItem" key={idx}>
                  <div className="ASIDItemGlAcctItemTotal">
                    {commonFn.iconDocFn({
                      iconKey: "ASIDGlacct",
                      width: 20,
                      height: 20,
                      marginRight: 4,
                    })}
                    <span className="ASIDItemGlAcctItemName">
                      {value.glAcct}
                    </span>
                    <span className="ASIDItemGlAcctItemAmount">
                      {commonFn.amountToDollarFn(value.yearGlTotal)}
                    </span>
                  </div>
                  {value?.batches?.length ? (
                    <div className="ASIDItemGlAcctItemInsuranceList">
                      {value.batches.map((v, batchIdx) => (
                        <div
                          className="ASIDItemGlAcctItemInsuranceItem"
                          key={batchIdx}
                        >
                           <RemarkPopover propRecord={v}>
                          <span>
                            {moment([
                              v.pushTime[0],
                              v.pushTime[1] - 1,
                              v.pushTime[2],
                            ]).format("MM/DD/YYYY")}
                          </span>
                          </RemarkPopover>
                          {/* <span>{v.number}</span> */}
                         <PolicyNumber propRecord={propRecord} v={v} />
                          <RemarkPopover propRecord={v}>
                          <span>{commonFn.amountToDollarFn(v.amount)}</span>
                          </RemarkPopover>
                        </div>
                      ))}
                    </div>
                  ) : null}
                </div>
              ))
            ) : (
              <div className="ASIDItemGlAcctNoData">No Data</div>
            )}
          </div>
        </div>
      );
    });

  const amountDoc = (
    <>
      <div className="ASIDList">
        {loading ? (
          <div className="ASIDLoading">Loading...</div>
        ) : VPHList.length > 0 ? (
          renderCards(VPHList, true)
        ) : (
          <div className="ASIDNoData">No payment history data</div>
        )}
      </div>

      <div className="ASIDSection">
        <div className="ASIDSectionTitle">Pending Submission</div>
        <div className="ASIDList">
          {VPHGLAcct.length > 0 ? (
            renderCards(VPHGLAcct, false)
          ) : (
            <div className="ASIDNoData">No pending submission</div>
          )}
        </div>
      </div>
    </>
  );

  const unitDoc = (
    <div style={{ width: "40vw" }}>
      <PropDetailModal
        ref={propDetailModalRef}
        detailUrl={api.ASInsurancePropDetails}
        tableUrl={api.ASInsuranceUnitDetails}
      />
    </div>
  );

  return (
    <Drawer
      title="View Payment History"
      placement="right"
      rootClassName="ASInsuranceDrawer"
      maskClosable={false}
      onClose={handleClose}
      open={drawerOpen}
      width="40vw"
      styles={{
        body: {
          width: "40vw",
          overflow: "auto",
        },
      }}
    >
      <div className="ASIDTitle">Prop：{VPHprop}</div>
      <Tabs
        activeKey={tabsKey}
        items={[
          {
            key: "1",
            label: "Payment History",
            forceRender: true,
            children: amountDoc,
          },
          {
            key: "2",
            label: "Unit Information",
            forceRender: true,
            children: unitDoc,
          },
        ]}
        onChange={(key) => setTabsKey(key)}
      />
    </Drawer>
  );
});

MainTable.displayName = "InsuranceVPH";

export default MainTable;
